import { OptionType } from '@components/Select';
import { store } from '@store';
import { EntryType } from '@template/store/entryType/EntryType';
import { toArrayFromIterable } from '@utils/toArrayFromIterable';
import { assertIsDefined } from '@utils/assertIsDefined';
import { EntryTypeField } from '@template/store/entryType/EntryTypeField';
import { Optional } from 'chaika-common-types';

export class EntryEntryTypeHelper {
    public static makeOptionsFromField(fieldName: string): OptionType<string>[] {
        const entryTypeWithFields = this.entryEntryTypes.find(entryType => !!entryType.getFieldByName(fieldName));
        if (!entryTypeWithFields) {
            return [];
        }

        const field = entryTypeWithFields.getFieldByName(fieldName);
        assertIsDefined(field, `Entry type is found by its field ${fieldName}`);

        return entryTypeWithFields.makeOptionsFromField(field);
    }

    public static getAllFieldsOptions(): OptionType<string>[] {
        return this.entryEntryTypes.flatMap(entryType => entryType.makeFieldsOptions());
    }

    public static getFieldByName(fieldName: string): Optional<EntryTypeField> {
        return this.entryFields.find(({ name }) => name === fieldName);
    }

    public static getFieldBlockTitleByName(fieldName: string): Optional<string> {
        const entryTypeWithFields = this.entryEntryTypes.find(entryType => !!entryType.getFieldByName(fieldName));
        return entryTypeWithFields?.getFieldBlockTitleByName(fieldName);
    }

    public static get entryFields(): EntryTypeField[] {
        return this.entryEntryTypes.flatMap(entryType => entryType.fields);
    }

    private static get entryEntryTypes(): EntryType[] {
        const { entryType, soapEntryType } = store.entry;
        return [entryType, ...toArrayFromIterable(soapEntryType)];
    }
}
